export default __webpack_public_path__ + "static/media/1977.2ce2ead6.png";